import styled from "styled-components";
export const ErrorMessage = styled.div `
  color: #ba3939;
  background: #ffe0e0;
  border: 1px solid #a33a3a;
  padding: 0.3rem;
`;
